import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { PatientReportDocumentService } from '@modules/patient/patient-report-document/patient-report-document.service';
import { SequencePickerInputComponent } from '@modules/sequence/sequence-picker-input/sequence-picker-input.component';
import { PdfPreviewerComponent } from '@modules/shared/pdf-previewer/pdf-previewer.component';
import { SpinnerComponent } from '@modules/shared/spinner/spinner.component';
import { Store } from '@ngrx/store';
import { Department, Patient } from '@pixacare/domain';
import { CollaborativeDepartmentsPickerComponent } from '@shared/collaborative-departments-picker/collaborative-departments-picker.component';
import { SequenceContext } from '@shared/models/enums/sequence-context.enum';
import { ReportTemplatePickerComponent } from '@shared/report-template-picker/report-template-picker.component';
import { selectUserEnabledClientDepartments } from '@shared/store/departments/departments.selectors';
import { TuiBlockStatus } from '@taiga-ui/layout';
import { Observable } from 'rxjs';

@Component({
  selector: 'pxc-patient-report-document',
  imports: [
    AsyncPipe,
    CollaborativeDepartmentsPickerComponent,
    PdfPreviewerComponent,
    ReactiveFormsModule,
    ReportTemplatePickerComponent,
    SequencePickerInputComponent,
    SpinnerComponent,
    TranslocoDirective,
    TuiBlockStatus,
  ],
  templateUrl: './patient-report-document.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class PatientReportDocumentComponent implements OnInit {
  readonly clientCode = input.required<string>();
  readonly patient = input.required<Patient>();
  readonly departmentIds = input<number[]>([]);

  private readonly authenticationService = inject(AuthenticationService);
  private readonly store = inject(Store);
  private readonly patientReportDocumentService = inject(PatientReportDocumentService);

  protected readonly pdfPreview$ = this.patientReportDocumentService.pdfPreview$;
  protected readonly form = this.patientReportDocumentService.form;
  protected readonly templates$ = this.patientReportDocumentService.templates$;

  protected departments$: Observable<Department[]>;

  protected readonly sequenceContext = SequenceContext.SEQUENCE;

  ngOnInit(): void {
    this.departments$ = this.store.select(
      selectUserEnabledClientDepartments(this.clientCode(), this.authenticationService.user.id),
    );

    this.patientReportDocumentService.init(this.clientCode(), this.patient().id, this.departmentIds());
  }
}
